import { fromExistingCodeDataList } from './ExistingCodeData.js';
import { requireObject } from './parse.js';

/**
 * Mirrors com.medprompt.content.codes.ExistingPatientCodes
 *
 * @typedef {object} ExistingPatientCodesData
 * @property {import('./ExistingCodeData.js').ExistingCodeData[]} activeCodes
 * @property {import('./ExistingCodeData.js').ExistingCodeData[]} significantPastCodes
 */

/**
 * @param {object} raw
 * @returns {ExistingPatientCodesData}
 */
export function fromExistingPatientCodesData(raw) {
  const source = requireObject(raw, 'ExistingPatientCodes');
  return {
    activeCodes: fromExistingCodeDataList(source.activeCodes),
    significantPastCodes: fromExistingCodeDataList(source.significantPastCodes),
  };
}
